// extracted by mini-css-extract-plugin
module.exports = {"team":"team-result_team__zE_la","row":"team-result_row__8HrT9"};